import React from 'react';
import { RouteComponentProps } from 'react-router';

import { PriceGuidePathContext } from '../shared/url_helpers';
import PriceGuideToolIndex from '../price_guide_tool/index/price_guide_tool_index';
import PriceGuideToolShow from '../price_guide_tool/show/price_guide_tool_show';

type IProps = RouteComponentProps<{}, PriceGuidePathContext>;

export function PriceGuidePage({
  params = {},
  location,
}: IProps) {

  return params.cspSlug ? (
    <PriceGuideToolShow
      routeParams={{ cspSlug: params.cspSlug }}
      location={location}
    />
  ) : (
    <PriceGuideToolIndex location={location} />
  );
}

export default PriceGuidePage;
